<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Akte {{versichertenNr}}</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body" style="
    height: Calc(90vh - 50px);
">
  <DataGridView [DataUrl]="dataurl()" #Grid KeyProperty="key">

  </DataGridView>





  <ng-template #buttonTemplate let-data>
    <div class="btn btn-sm btn-primary bi bi-pencil-fill" (click)="OpenAkte(data)"></div>
  </ng-template>
</div>
